module.exports = __webpack_public_path__ + "img/information.0a54ba1.png";